// Extracting the base URL
export const baseURL = currentUrl => {
  const url = new URL(currentUrl);
  return `${url.protocol}//${url.hostname}${url.port ? `:${url.port}` : ''}`;
};

export default { baseURL };
